import React from 'react';
import { privacyChoices } from '../data/privacyChoices';
export const PrivacySection: React.FC = () => {
  return <section id="choices" aria-labelledby="choices-heading" className="section-y bg-cloud" data-id="element-170" data-mp="1iuuuesxqig8r">
      <div className="section-container grid grid-cols-1 gap-10 lg:grid-cols-[1fr_1.2fr] lg:gap-16" data-id="element-171" data-mp="153zjlb3odp2j">
        <div data-id="element-172" data-mp="194je06wv6ekz">
          <h2 id="choices-heading" className="section-heading" data-id="element-173" data-mp="191xacid3gj81">
            Your story. Your choices.
          </h2>
          <p className="section-lead mt-5" data-id="element-174" data-mp="21sp1v2j7sjp1">
            We’re designing Re:Joy to help you understand how your information
            is used and take an active role in what you share.
          </p>
        </div>

        <ul className="divide-y divide-mist-sage/70 border-y border-mist-sage/70" data-id="element-175" data-mp="1srqxgj4v6a5x">
          {privacyChoices.map(choice => <li key={choice.title} className="flex gap-4 py-6" data-id="element-176" data-mp="ccpk4x1j5lxs">
              <span aria-hidden="true" className="mt-2 h-2.5 w-2.5 flex-shrink-0 rounded-full bg-rejoy-coral" data-id="element-177" data-mp="hcke59glqrn2" />
              <div data-id="element-178" data-mp="3trgywig9qc7r">
                <h3 className="text-xl" data-id="element-179" data-mp="3tt1t26yo7t53">{choice.title}</h3>
                <p className="mt-1 leading-relaxed text-plum-gray" data-id="element-180" data-mp="3otff1vb0q8v8">
                  {choice.description}
                </p>
              </div>
            </li>)}
        </ul>
      </div>
    </section>;
};